export const getHeight = () => {
    return window.innerHeight-120;
}
export const getWidth = () => {
    return window.innerWidth;
}
export const sortAsc = (array)=>{
    array.sort((a, b) => (b.name > a.name ? -1 : 1))
    return array
}